import Image from "next/image";
/* Small pieces shared by the /learn hub, course and lesson pages, so the three
   read as one product. Flat panels and hairlines only (brand/visual-style). */

export const panel = { background: "var(--panel)", borderColor: "var(--hairline-strong)" };
export const inset = { background: "var(--inset)", borderColor: "var(--hairline)" };

export function Eyebrow({
  children,
  id,
  className = "mb-3",
  muted = false,
}: {
  children: React.ReactNode;
  id?: string;
  className?: string;
  /* Grey instead of gold, for labels inside panels. */
  muted?: boolean;
}) {
  return (
    <p
      id={id}
      className={`font-accent text-[11px] font-medium uppercase tracking-[0.22em] ${
        muted ? "text-muted-foreground" : "text-eyebrow"
      } ${className}`}
    >
      {children}
    </p>
  );
}

export function Pill({ children, gold = false }: { children: React.ReactNode; gold?: boolean }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold"
      style={
        gold
          ? { background: "var(--icon-gold-bg)", color: "var(--icon-gold-text)" }
          : { border: "1px solid var(--hairline-strong)", color: "var(--muted-foreground)" }
      }
    >
      {children}
    </span>
  );
}

/* Author photo when there is one, otherwise a gold initials tile. */
export function Initials({
  name,
  image,
  size = "md",
}: {
  name: string;
  image?: string;
  size?: "sm" | "md";
}) {
  const box = size === "sm" ? "h-9 w-9 rounded-xl text-[13px]" : "h-14 w-14 rounded-2xl text-[18px]";
  if (image) {
    return (
      <span className={`relative block shrink-0 overflow-hidden ${box}`} style={{ background: "#ffe500" }}>
        <Image src={image} alt={name} fill sizes="56px" className="object-cover object-[50%_20%]" />
      </span>
    );
  }
  return (
    <span
      className={`flex shrink-0 items-center justify-center font-heading font-bold text-black ${box}`}
      style={{ background: "#ffe500" }}
      aria-hidden
    >
      {name
        .split(" ")
        .map((p) => p[0])
        .join("")}
    </span>
  );
}
